// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._SZ2ij {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  flex: 1;
}

.Puocjy {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: var(--spacing-3);
  flex: 1;
}

/* Success Section */
.W2WpCR {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.WrkgsQ {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--type-subtitle-md-font-size);
  line-height: var(--type-subtitle-md-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  max-width: 685px;
}

.EEVUp3 {
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: stretch;
  align-self: stretch;
  gap: var(--spacing-2);
}

.TG9i_C {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  flex: 1;
}

.gCREdB {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--type-paragraph-md-font-size);
  line-height: var(--type-paragraph-md-line-height);
  color: var(--text-neutral-dark);
  height: 21px;
}

.CIYlt9 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--type-subtitle-md-font-size);
  line-height: var(--type-subtitle-md-line-height);
  color: var(--text-neutral-dark);
}

/* Divider */
.gbNlaW {
  height: 1px;
  width: 100%;
  background-color: var(--surface-neutral-soft);
  align-self: stretch;
  margin: var(--spacing-1) 0;
}

/* Barcode Section */
.dbXuFk {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.pJoAMS {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  align-self: stretch;
  gap: var(--spacing-3);
}

.pJoAMS > div:first-child {
  flex: 1;
}

.mTreU1 {
  flex-shrink: 0;
}

/* Instructions Section */
.oLoNYM {
  display: flex;
  flex-direction: column;
}

.eqa3hq {
  display: flex;
  flex-direction: row;
  align-self: stretch;
  gap: var(--spacing-0-5);
  padding: 0 var(--spacing-0-5);
}

.pO6TUX {
  width: 12px;
  height: 18px;
  color: var(--status-info);
  flex-shrink: 0;
}

.AWQutc {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--type-caption-sm-font-size);
  line-height: var(--type-caption-sm-regular-line-height);
  color: var(--text-neutral-stronger);
  flex: 1;
}

/* Responsive: Tablet e Mobile (até 1023px) */
@media (max-width: 1023px) {
  .pJoAMS {
    flex-direction: column;
    align-items: stretch;
    gap: var(--spacing-2);
  }

  .mTreU1 {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/DepositBilletSteps/BilletGeneratedStep/BilletGeneratedStep.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,OAAO;AACT;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,4CAA4C;EAC5C,gDAAgD;EAChD,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,6CAA6C;EAC7C,iDAAiD;EACjD,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,4CAA4C;EAC5C,gDAAgD;EAChD,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,WAAW;EACX,6CAA6C;EAC7C,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,2CAA2C;EAC3C,uDAAuD;EACvD,mCAAmC;EACnC,OAAO;AACT;;AAEA,6CAA6C;AAC7C;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  flex: 1;\n}\n\n.contentContainer {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: var(--spacing-3);\n  flex: 1;\n}\n\n/* Success Section */\n.successSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n}\n\n.successTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--type-subtitle-md-font-size);\n  line-height: var(--type-subtitle-md-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  max-width: 685px;\n}\n\n.amountInfo {\n  display: flex;\n  flex-direction: row;\n  justify-content: stretch;\n  align-items: stretch;\n  align-self: stretch;\n  gap: var(--spacing-2);\n}\n\n.amountGroup {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  flex: 1;\n}\n\n.amountLabel {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--type-paragraph-md-font-size);\n  line-height: var(--type-paragraph-md-line-height);\n  color: var(--text-neutral-dark);\n  height: 21px;\n}\n\n.amountValue {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--type-subtitle-md-font-size);\n  line-height: var(--type-subtitle-md-line-height);\n  color: var(--text-neutral-dark);\n}\n\n/* Divider */\n.divider {\n  height: 1px;\n  width: 100%;\n  background-color: var(--surface-neutral-soft);\n  align-self: stretch;\n  margin: var(--spacing-1) 0;\n}\n\n/* Barcode Section */\n.barcodeSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n}\n\n.barcodeContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  align-self: stretch;\n  gap: var(--spacing-3);\n}\n\n.barcodeContainer > div:first-child {\n  flex: 1;\n}\n\n.copyButton {\n  flex-shrink: 0;\n}\n\n/* Instructions Section */\n.instructionsSection {\n  display: flex;\n  flex-direction: column;\n}\n\n.instructionsContent {\n  display: flex;\n  flex-direction: row;\n  align-self: stretch;\n  gap: var(--spacing-0-5);\n  padding: 0 var(--spacing-0-5);\n}\n\n.instructionsIcon {\n  width: 12px;\n  height: 18px;\n  color: var(--status-info);\n  flex-shrink: 0;\n}\n\n.instructionsText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--type-caption-sm-font-size);\n  line-height: var(--type-caption-sm-regular-line-height);\n  color: var(--text-neutral-stronger);\n  flex: 1;\n}\n\n/* Responsive: Tablet e Mobile (até 1023px) */\n@media (max-width: 1023px) {\n  .barcodeContainer {\n    flex-direction: column;\n    align-items: stretch;\n    gap: var(--spacing-2);\n  }\n\n  .copyButton {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `_SZ2ij`,
	"contentContainer": `Puocjy`,
	"successSection": `W2WpCR`,
	"successTitle": `WrkgsQ`,
	"amountInfo": `EEVUp3`,
	"amountGroup": `TG9i_C`,
	"amountLabel": `gCREdB`,
	"amountValue": `CIYlt9`,
	"divider": `gbNlaW`,
	"barcodeSection": `dbXuFk`,
	"barcodeContainer": `pJoAMS`,
	"copyButton": `mTreU1`,
	"instructionsSection": `oLoNYM`,
	"instructionsContent": `eqa3hq`,
	"instructionsIcon": `pO6TUX`,
	"instructionsText": `AWQutc`
};
module.exports = ___CSS_LOADER_EXPORT___;
